module.exports = __webpack_public_path__ + "img/tema-3-19.b7f6a54e.svg";